import React, { FormEvent } from 'react';
import { Button } from 'src/components/Button';
import { InputText } from 'src/components/InputText';
import { UseFormReturn } from 'src/hooks';
import { FormInputChangePassoword } from '../../types';

interface ChangePasswordWithCodeUIProps
  extends Pick<UseFormReturn, 'formData' | 'formErrors' | 'onChangeFormInput'> {
  onSubmit: (e: FormEvent) => void;
}

export const ChangePasswordWithCodeUI: React.FC<
  ChangePasswordWithCodeUIProps
> = ({ formData, formErrors, onChangeFormInput, onSubmit }) => {
  return (
    <div className="flex items-center justify-center bg-white  px-4">
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-2 text-center">
          Recuperar Senha
        </h2>
        <p className="text-sm text-gray-600 mb-6 text-center">
          Informe o código enviado para seu e-mail e a nova senha.
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          {/* Código */}
          <InputText
            name="code"
            label="Código"
            placeholder="Digite o código"
            value={formData[FormInputChangePassoword.code]}
            onChange={(e) =>
              onChangeFormInput(FormInputChangePassoword.code)(e.target.value)
            }
            error={formErrors.code && formErrors.code[0]}
            inputClassName="w-full p-3 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500"
          />

          {/* Nova Senha */}
          <InputText
            name="newPassword"
            type="password"
            label="Nova Senha"
            placeholder="Digite a nova senha"
            value={formData[FormInputChangePassoword.newPassword]}
            onChange={(e) =>
              onChangeFormInput(FormInputChangePassoword.newPassword)(
                e.target.value
              )
            }
            error={formErrors.newPassword && formErrors.newPassword[0]}
            inputClassName="w-full p-3 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500"
          />

          {/* Confirmar Nova Senha */}
          <InputText
            name="confirmPassword"
            type="password"
            label="Confirmar Nova Senha"
            placeholder="Confirme a nova senha"
            value={formData[FormInputChangePassoword.confirmPassword]}
            onChange={(e) =>
              onChangeFormInput(FormInputChangePassoword.confirmPassword)(
                e.target.value
              )
            }
            error={formErrors.confirmPassword && formErrors.confirmPassword[0]}
            inputClassName="w-full p-3 rounded-lg border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-red-500"
          />

          <Button
            type="submit"
            title="Alterar Senha"
            buttonStyle="red"
            size="lg"
            className="w-full mt-4"
            disabled={
              !formData[FormInputChangePassoword.code] ||
              !formData[FormInputChangePassoword.newPassword] ||
              !formData[FormInputChangePassoword.confirmPassword]
            }
          />
        </form>
      </div>
    </div>
  );
};
